<template>
<div class="cart-block__item grid-column-2 mobile-column-1" :data-id="item.ID">
    <div class="grid-column-2 grid-with-gap">
        <span class="cart-item-image">
            <img :src="item.detailPictureSrc" :alt="item.name"/>
            <!--<a href="" class="cross zoom"></a>-->
        </span>
        <span class="cart-item-title">
            <a :href="item.detailPageUrl">{{ item.name }}</a>
        </span>
    </div>
    <div class="grid-column-2">
        <span class="cart-item-text">{{ item.price }}р</span>
        <span class="cart-item-text">{{ item.sumValue }}р</span>
        <span class="cart-item-text">
            <a class="like-button" href="#" @click.prevent="decrement()">-</a>
            {{ item.quantity }}
            <a class="like-button" href="#" @click.prevent="increment()">+</a>
        </span>
        <span class="cart-item-text">
            <a href="#" class="cross delete" @click.prevent="remove"></a>
        </span>
    </div>
</div>
</template>

<script>
export default {
    model: {
        prop: 'item',
        event: 'change',
    },
    props: {
        item: Object,
    },

    methods: {
        increment() {
            this.$emit('change', {
                id: this.item.id,
                quantity: this.item.quantity + 1,
            });
        },

        decrement() {
            this.$emit('change', {
                id: this.item.id,
                quantity: this.item.quantity - 1,
            });
        },

        remove() {
            this.$emit('remove', {
                id: this.item.id,
            });
        }
    },
}
</script>
